var _style, _metadata, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 850.4 850.4",
    style: {
      enableBackground: "new 0 0 850.4 850.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.Drop_x0020_Shadow{fill:none;}\r\n\t.Round_x0020_Corners_x0020_2_x0020_pt{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\r\n\t.Live_x0020_Reflect_x0020_X{fill:none;}\r\n\t.Bevel_x0020_Soft{fill:url(#SVGID_1_);}\r\n\t.Dusk{fill:#FFFFFF;}\r\n\t.Foliage_GS{fill:#FFDD00;}\r\n\t.Pompadour_GS{fill-rule:evenodd;clip-rule:evenodd;fill:#44ADE2;}\r\n")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 550.9,
    width: 708.7,
    x: 70.9,
    y: -700.6
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M526,695.8c67.9,1.6,115.9-12,166.6-32.7l42.1-16.9V513c0-52.3,15-84.5,44.9-96.7v-8.9H599.8v8.9 c34.9,7.2,52.3,34.7,52.3,82.4v66.6c0,29.3-3,49.3-8.9,60.2c-18.1,20.7-81.5,42.5-127.3,31.1c-73.5-18.3-79.8-62.3-80.2-177.5V292.9 c4.3-66.6,25-100.6,108.8-100.6c41.5,0,77.1,10.2,107.1,30.6c29.3,20.4,47.9,48.4,55.8,83.9h9.9c0-20.4-0.5-37.7-1.5-51.8 c-1-16.4-1.5-40-1.5-70.6C660,165,604,155.3,546.1,155.3l-110.3,0.6H267.6c-27.9,0-80.7-2-158.4-6.1c0.7,10.2,1,17.9,1,23 c0,6.8-0.8,22.7-2.6,47.5c-1,16.7-1.5,25.7-1.5,27.1v12.8h8.7c12.3-29.3,26.2-48.2,41.9-56.7c15.7-8.2,45.1-12.3,88.4-12.3h81.3 c13,0,24.9,0.9,35.8,2.6c6.1,11.6,9.7,39.2,10.7,82.8l1,34.7v83.3H263.5c-41.6,0-69.2-3.6-82.8-10.7c-13.6-7.2-24.5-24.2-32.7-51.1 h-11.2c2.7,30.7,4.1,57.2,4.1,79.7c0,14.3-1,33-3.1,56.2c-0.7,6.8-1.5,20.3-2.6,40.4h11.2c3.1-30,12.1-50.6,27.1-61.8 c15.3-11.2,39.3-16.9,72.1-16.9h128.3v111.4c0,42.9-2.4,80.6-7.2,112.9c-14.3,2-29.6,3.1-46,3.1h-77.7c-42.2,0-74.1-4.8-95.6-14.3 c-22.5-9.9-44.6-31.9-66.4-65.9H70.9c3.8,15.7,9.4,33.7,16.9,54.2c9.2,26.6,15.8,49.6,19.9,69c38.8-4.1,73.6-6.1,104.2-6.1h223.8 L526,695.8z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6a1cfff4595f751d1f7156ded779f592.svg";
export { ForwardRef as ReactComponent };